import capitalizeFirstLetter from './capitalizeFirstLetter';

function idToTitle(id?: string): string | undefined {
  if (!id) return undefined;
  return id.split('_').map((x) => capitalizeFirstLetter(x.toLowerCase())).join(' ');
}

export default idToTitle;
